<template>
  <div class="publish-purchase">
    <div class="flex justify-center" style="padding-top: 36px;">
      <button v-click-sound-button
              class="h-btn normal btn-border"
              @click="handleShowPublishPopup">
        发起收购
      </button>
    </div>

    <PurchaseRequestPopup v-if="publishPopupShow"
                          @close="publishPopupShow=false"
                          @refresh="onRefresh">
    </PurchaseRequestPopup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PurchaseRequestPopup from './purchase-request-popup'

export default {
  name: 'publish-purchase',

  components: {
    PurchaseRequestPopup,
  },

  data () {
    return {
      publishPopupShow: false,
    }
  },

  computed: {
    ...mapGetters('hero', [
      'gold'
    ]),

  },

  mounted () {
  },

  methods: {
    ...mapActions('hero', [
      'getGold',
    ]),

    handleShowPublishPopup () {
      this.publishPopupShow = true
    },

    onRefresh () {
    },
  },
}
</script>

<style lang="stylus" scoped>
  .publish-purchase
    position relative
    height 100%

</style>
